'use strict';
import { RRule, RRuleSet, rrulestr } from 'rrule';

/**
 * @ngdoc function
 * @name thothAppApp.controller:showGoogleCalendarCtrl
 * @description
 * # showGoogleCalendarCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('showGoogleCalendarCtrl', [
    '$scope',
    '$q',
    '$window',
    'SearchClientsAndProspects',
    'Activity',
    'Client',
    '$mdDialog',
    'ActivityTypeCatalog',
    'cfpLoadingBar',
    'toaster',
    'Project',
    'ProductCatalog',
    'FileSaver',
    'Employee',
    'Holyday',
    '$state',
    'GoogleCalendarEvents',
    function (
      $scope,
      $q,
      $window,
      SearchClientsAndProspects,
      Activity,
      Client,
      $mdDialog,
      ActivityTypeCatalog,
      cfpLoadingBar,
      toaster,
      Project,
      ProductCatalog,
      FileSaver,
      Employee,
      Holyday,
      $state,
      GoogleCalendarEvents,
    ){
    $scope.activityTypeCatalogs = [];
    $scope.activities = [];
    $scope.currentActivity = {};
    $scope.currentEmployee = {};
    $scope.newCurrentActivity = {};
    $scope.newActivity = {};
    $scope.activitiesGoogleCalendar = [];
    $scope.actionTypes = [
      { id: 'project', name: "Proyecto", summaryName:"P" },
      { id: 'support', name: "Soporte", summaryName:"S" },
      { id: 'quote', name: "Propuesta / Comercial", summaryName:"PC" },
      { id: 'rh', name: "Recursos Humanos" , summaryName:"RH"},
      { id: 'vacation', name: "Vacaciones / Incapacidades", summaryName:"VI" }
    ];
    $scope.actionTypesCatalogsSummary = ActivityTypeCatalog.getActivityTypesCatalogSummary();
    
    $scope.findActionTypeSummary = function(id) {
      var actionType = $scope.actionTypesCatalogsSummary.find(function(type) {
          return type.id === id;
      });
      return actionType ? actionType.summaryExtendedName : '';
    };
    $scope.productsAll = []

    $scope.findProductWithID = function(id) {
      var product = $scope.productsAll.find(function(type) {
        return type.id === id;
    });
    return product ? product.name : '';
    }

    $scope.favoriteActivities = [];
    $scope.currentActivity.description = undefined;
    $scope.modalTittle = "Importar actividad";
    $scope.currentActivity.favorite = false;
    $scope.selectedCustomer = undefined;
    $scope.searchCustomer = '';
    $scope.selectedProject = undefined;
    $scope.selectedTicket = undefined;
    $scope.searchProject = '';
    $scope.isDisabled = true;
    $scope.startOFWeek = undefined;
    $scope.endOFWeek = undefined;
    $scope.support = false;
    $scope.clearIcon = true;
    $scope.anyErrors = false;
    $scope.oldActivity = undefined;
    $scope.allDaySelected = false;
    $scope.daySelected = undefined;
    $scope.editable = true;
    $scope.selectedEmployee = {
        name: 'Todos',
        id: null
    };
    $scope.searchEmployee = '';
    $scope.selectedTicket = undefined;
    $scope.searchTicket = '';
    $scope.refreshCalendar = false;
    let errorShown = false;
    $scope.isProcessing = false;
    // let RRule = window.rrule.RRule;
    const SCISA_CUSTOMER_ID = 29;

    const googleDeps = () => ({ RRule: RRule });

    $scope.leftButtons = '';
    $scope.saveDate = '';

    $scope.ticketSearch = function(searchQuery) {
      if (!searchQuery) {
        return [];
      }
      var params = {
          'search': searchQuery
      };
      var deferred = $q.defer();
      Activity.getAllTickets(params).then((response) => {
        $scope.tickets = response.data;
        deferred.resolve($scope.tickets);
      }).catch((error) => {
        toaster.pop('error', 'Azure Devops', error.data.error);
        Activity.error(error);
        deferred.reject(error);
      });
      return deferred.promise;
    }

    $scope.selectedTicketChange = function(ticket) {
      if (ticket == undefined) {
        $scope.currentActivity.ticketId = null;
        $scope.currentActivity.ticketName = null;
      }else{
        $scope.currentActivity.ticketId = ticket.id;
        $scope.currentActivity.ticketName = ticket.title;
      }
    }

    $scope.removeScisaCustomerFromCollection = (collection, currentActivityActionType) => {
      if(collection.length > 0 && $scope.currentActivity.actionType === currentActivityActionType)
      {
        collection.forEach(item => {
          if(item.id == SCISA_CUSTOMER_ID){
            var index = collection.indexOf(item);
            collection.splice(index, 1)
          }
        });
      }
      return collection;
    }

    $scope.selectedEmployeeIsCurrentEmployee = function() {
      if ($scope.userhasEmployee()){
        if (JSON.parse($window.localStorage.apiUser).employee.id == $scope.selectedEmployee.id) {
          return true;
        } else {
          return false;
        }
      }
    }
    $scope.userhasEmployee = function() {
      if ('apiUser' in $window.localStorage) {
        const apiUser = JSON.parse($window.localStorage.apiUser);
        if([undefined, null].includes(apiUser.employee)) {
          return false;
        } else {
          return true;
        }
      } else {
        toaster.pop('error', 'Usuario', 'Ocurrio un error, favor de ponerse en contacto con soporte');
        return false;
      }
    }

    $scope.updateActionType = function() {
      $scope.clearIcon = true;
      $scope.selectedCustomer = undefined;
      $scope.selectedProject = undefined;
      $scope.selectedTicket = undefined;
      $scope.currentActivity.projectId = null;
      $scope.currentActivity.projectName = null;
      $scope.currentActivity.clientId = null;
      $scope.currentActivity.clientName = null;
      $scope.currentActivity.project_code = null;
      $scope.currentActivity.activityTypeCatalogId = null;
      $scope.currentActivity.productId = null;
      $scope.currentActivity.ticketId = null;
      $scope.currentActivity.ticketName = null;
      if ($scope.currentActivity.actionType === 'internal') {
      $scope.clearIcon = false;
      $scope.currentActivity.clientId = Number(sessionStorage.default_customer_id);
      $scope.currentActivity.clientName = sessionStorage.default_customer_name;
      $scope.currentActivity.ownerableType = 'Client';
      $scope.selectedCustomer = {
        id: sessionStorage.default_customer_id,
        name: sessionStorage.default_customer_name
      }

    }else if ($scope.currentActivity.actionType === 'rh') {
      $scope.clearIcon = false;
      $scope.currentActivity.clientId = Number(sessionStorage.default_customer_id);
      $scope.currentActivity.clientName = sessionStorage.default_customer_name;
      $scope.currentActivity.ownerableType = 'Client';
      $scope.selectedCustomer = {
        id: sessionStorage.default_customer_id,
        name: sessionStorage.default_customer_name
      }
    }else if ($scope.currentActivity.actionType === 'project') {
      $scope.selectedCustomer = undefined;
      $scope.selectedproject = undefined;
      $scope.clearIcon = false;
    }else if ($scope.currentActivity.actionType === 'vacation') {
      $scope.currentActivity.description = "Vacaciones / Incapacidades"
    }
  }


  $scope.selectedCustomerOrProspectChange = (customerOrProspect) => {
    if (customerOrProspect == undefined) {
      $scope.currentActivity.clientId = undefined;
      $scope.currentActivity.ownerableType = undefined;
      errorShown = false;
    } else if (customerOrProspect.search_type === "Client") {
      $scope.currentActivity.clientId = customerOrProspect.id;
      $scope.currentActivity.clientName = customerOrProspect.name;
      $scope.currentActivity.ownerableType = "Client";
      validateCustomerAndFilterProducts(customerOrProspect.id, "Client");
      errorShown = false;
    } else if (customerOrProspect.search_type === "Prospect") {
      $scope.currentActivity.clientId = customerOrProspect.id;
      $scope.currentActivity.clientName = customerOrProspect.name;
      $scope.currentActivity.ownerableType = "Prospect";
      validateCustomerAndFilterProducts(customerOrProspect.id, "Prospect");
      errorShown = false;
    }
  };


  $scope.employeeSearch = (searchQuery) => {
    if (!searchQuery) {
      return [];
    }
    var employeeParams = {
      'params': {
          'search': searchQuery
      }
    };
    var deferred = $q.defer();
    var allEmployees = {
      name: "Todos",
      id: null
    };
    Employee.index(employeeParams).then((response) => {
      let response_data = response.data.employees;
      response_data.unshift(allEmployees)
      deferred.resolve(response_data);
    }).catch((error) => {
      Employee.error(error);
      deferred.reject(error);
    });
    return deferred.promise;
  };

  $scope.selectedEmployeeChange = (employee) => {
    if (employee != undefined){
      if (employee.id != null) {
        $scope.currentEmployee.employeeId = employee.id
        $scope.viewObject.calendar.refetchEvents();
      }
    }else{
        $scope.viewObject.calendar.refetchEvents();

    }
  }

  $scope.customerOrProspectSearch = (searchQuery) => {
    if (!searchQuery) {
      return [];
    }
    var customerOrProspectParams = {
      'params': {
          'search': searchQuery
      }
    };
    var deferred = $q.defer();
    SearchClientsAndProspects.index(customerOrProspectParams).then((response) => {
      let clients_prospects = [];
      let response_data = $scope.removeScisaCustomerFromCollection(response.data, "quote");
      response_data[0].map(item => {
        clients_prospects.push(item)
      })
      response_data[1].map(item => {
        clients_prospects.push(item);
      })
      deferred.resolve(clients_prospects);
    }).catch((error) => {
      Client.error(error);
      deferred.reject(error);
    });
    return deferred.promise;
  };


  $scope.selectedCustomerChange = (customer) => {
    if (customer == undefined) {
      $scope.currentActivity.clientId = undefined;
      $scope.currentActivity.ownerableType = undefined;
    } else {
      if ($scope.currentActivity.actionType === "support") {
        $scope.currentActivity.clientId = customer.id;
        $scope.currentActivity.clientName = customer.name;
        $scope.currentActivity.ownerableType = "Client";
        validateCustomerAndFilterProducts(customer.id, "Client");
        errorShown = false;
      } else {
        if ($scope.currentActivity.actionType == 'rh' || $scope.currentActivity.actionType == 'internal') {
          $scope.currentActivity.clientId = customer.id;
          $scope.currentActivity.clientName = customer.name;
          $scope.currentActivity.ownerableType = "Client";
        }
      }
    }
  };

  const validateCustomerAndFilterProducts = async (customer, type) => {
    if (customer) {
      if (type !== "Client") {
        filterProducts([], "Prospect");
      } else {
        try {
          const response = await Client.find(customer);
          customer = response.data.client;
        } catch (error) {
          console.error("Error fetching data:", error);
        }
        if (customer.client_product_catalogs.length === 0 && !errorShown) {
          toaster.pop('error', 'Actividad', "Se tienen que configurar los productos del cliente");
          filterProducts([], customer.ownerable_type);
          errorShown = true;
        } else if (customer.client_product_catalogs.length > 0) {
          filterProducts(customer.client_product_catalogs.map(productCatalog => productCatalog.product_catalog_id), customer.ownerable_type);
        }
      }
    }
  }

  $scope.customerSearch = (searchQuery) => {
    if (!searchQuery) {
      return [];
    }
    var customerParams = {
      'params': {
        'search': searchQuery
      }
    };
    var deferred = $q.defer();
    Client.index(customerParams).then((response) => {
      let response_data = $scope.removeScisaCustomerFromCollection(response.data.clients, "support");
      deferred.resolve(response_data);
    }).catch((error) => {
      Client.error(error);
      deferred.reject(error);
    });
    return deferred.promise;
  };


  $scope.selectedProjectChange = (project) => {
    if (project === undefined) {
      $scope.selectedCustomer = undefined;
      $scope.selectedProject = undefined;
      $scope.currentActivity.projectId = undefined;
      $scope.currentActivity.projectName = undefined;
      $scope.currentActivity.clientId = undefined;
      $scope.currentActivity.clientName = undefined;
      $scope.currentActivity.ownerableType = undefined;
      $scope.currentActivity.project_code = undefined;
    }else {
      $scope.currentActivity.projectId = project.id
      $scope.currentActivity.projectName = project.name
      $scope.currentActivity.clientId = project.client_id
      $scope.currentActivity.clientName = project.client_name
      $scope.currentActivity.ownerableType = "Client"
      $scope.currentActivity.project_code = project.project_code
      $scope.clearIcon = false;
      $scope.selectedCustomer = {
        id: project.client_id,
        name: project.client_name
      }
    }
  }

  $scope.projectSearch = (searchQuery) => {
    return Project.searchWithCache(searchQuery);
  };




  $scope.searchClientOrganizerEvent = async (searchQueries) => {
    var deferred = $q.defer();
    for (let i = 0; i < searchQueries.length; i++) {
        let searchQuery = searchQueries[i];
        if (!searchQuery) {
            continue;
        }
        var projectParams = {
            'params': {
              'search': searchQuery
            }
        };
        await Client.index(projectParams).then((response) => {
            var firstProduct = response.data.clients[0];
            if (firstProduct) {
                var firstEventInfo = {
                    client_id: firstProduct.id,
                    client_name: firstProduct.name,
                    product_id: firstProduct.client_product_catalogs[0] ? firstProduct.client_product_catalogs[0].id : null,
                };
                deferred.resolve(firstEventInfo);
                return deferred.promise;
            }
        }).catch((error) => {
            Project.error(error);
            deferred.reject(error);
        });
    }
    deferred.resolve(null);
    return deferred.promise;
};


  const getCatalogParmas = () => {
    const ActivityTypeCatalogsPromise = ActivityTypeCatalog.index({
      params: {
        per_page: "all"
      }
    }).then((response) => {
      $scope.activityTypeCatalogs = response.data.activity_type_catalogs;
    }).catch(error => {
      console.error(error);
    });

    const getProducts = ProductCatalog.index().then((response) => {
      $scope.productsAll = response.data.products;
      var res = response.data.products;
      $scope.productsUnfiltered = res.filter(data => data.name != 'SIA' && data.name != 'Framework' && data.name != 'SICAJAS');
    })
    .catch(error => {
      console.error(error);
    });

    return Promise.all([ActivityTypeCatalogsPromise, getProducts]);
  }

  const filterProducts = (customerProducts,type) => {
    if (type === "Prospect") {
      $scope.products = $scope.productsUnfiltered;
    } else {
      $scope.products = $scope.productsUnfiltered.filter(data => customerProducts.includes(data.id));
    }
  }

  const parseSaveActivity = () => {
    let ownerable_id = $scope.currentActivity.clientId;
    $scope.currentActivity.recentActivity = null;
    if($scope.currentActivity.actionType == 'vacation'){
      ownerable_id = null;
      $scope.currentActivity.ownerableType = null;
    }
    return {
      id: $scope.currentActivity.id,
      begins_at: $scope.currentActivity.startDate,
      ends_at: $scope.currentActivity.endDate,
      description: $scope.currentActivity.description,
      activity_type_catalog_id: $scope.currentActivity.activityTypeCatalogId,
      action_type: $scope.currentActivity.actionType,
      ownerable_id: ownerable_id,
      ownerable_type: $scope.currentActivity.ownerableType,
      project_id: $scope.currentActivity.projectId,
      project_code: $scope.currentActivity.projectCode,
      product_catalog_id: $scope.currentActivity.productId,
      ticket_id: $scope.currentActivity.ticketId,
      ticket_name: $scope.currentActivity.ticketName,
      google_calendar_id:  $scope.currentActivity.google_calendar_id,
      google_calendar_event: $scope.currentActivity.google_calendar_event,
      attendees: $scope.currentActivity.attendees
        ? JSON.stringify($scope.currentActivity.attendees)
        : null,
      is_favorite: $scope.currentActivity.favorite
    };
  }

  const parseCurrentActivity = (selectedActivity) => {
    if(selectedActivity.actionType === "internal") {
      $scope.currentActivity = {
        id: selectedActivity.id,
        startDate: selectedActivity.start,
        endDate: selectedActivity.end,
        description: selectedActivity.description,
        clientId: Number(sessionStorage.default_customer_id),
        clientName: sessionStorage.default_customer_name,
        ownerableType: selectedActivity.ownerableType,
        activityTypeCatalogId: selectedActivity.activityTypeCatalogId,
        actionType: selectedActivity.actionType,
        shortTitle: selectedActivity.shortTitle
      }
      $scope.selectedCustomer = {
        id: sessionStorage.default_customer_id,
        name: sessionStorage.default_customer_name
      }
    } else if(selectedActivity.actionType === "rh") {
      $scope.currentActivity = {
        id: selectedActivity.id,
        startDate: selectedActivity.start,
        endDate: selectedActivity.end,
        description: selectedActivity.description,
        clientId: Number(sessionStorage.default_customer_id),
        clientName: sessionStorage.default_customer_name,
        ownerableType: selectedActivity.ownerableType,
        actionType: selectedActivity.actionType,
        shortTitle: selectedActivity.shortTitle
      }
      $scope.selectedCustomer = {
        id: sessionStorage.default_customer_id,
        name: sessionStorage.default_customer_name
      }
    } else if(selectedActivity.actionType === "vacation") {
      $scope.currentActivity = {
        id: selectedActivity.id,
        startDate: selectedActivity.start,
        endDate: selectedActivity.end,
        actionType: selectedActivity.actionType,
        description: "Vacaciones / Incapacidades",
        shortTitle: selectedActivity.shortTitle
      }
    }else {
      $scope.currentActivity = {
        id: selectedActivity.id,
        startDate: selectedActivity.start,
        endDate: selectedActivity.end,
        description: selectedActivity.description,
        clientId: selectedActivity.clientId,
        clientName: selectedActivity.clientName,
        ownerableType: selectedActivity.ownerableType,
        activityTypeCatalogId: selectedActivity.activityTypeCatalogId,
        actionType: selectedActivity.actionType,
        projectId: selectedActivity.projectId,
        projectCode: selectedActivity.projectCode,
        productId: selectedActivity.productId,
        shortTitle: selectedActivity.shortTitle,
        ticketId: selectedActivity.ticketId,
        ticketName: selectedActivity.ticketName
      }

      if (selectedActivity.clientId !== null && selectedActivity.clientName !== null) {
        $scope.selectedCustomer = {
          id: selectedActivity.clientId,
          name: selectedActivity.clientName
        };
      }
    }

    if(selectedActivity.actionType === "project" && selectedActivity.projectId !== null && selectedActivity.projectName !== null  ) {
      $scope.selectedProject = {
        id: selectedActivity.projectId,
        name: selectedActivity.projectName,
        client_id: selectedActivity.clientId,
        client_name: selectedActivity.clientName,
        code: selectedActivity.project_code
      }
    }

    if ((selectedActivity.actionType == "support" || selectedActivity.actionType === "project") && selectedActivity.ticketId != null) {
      $scope.selectedTicket = {
        id: selectedActivity.ticketId,
        title: selectedActivity.ticketName
      }
    }

    $scope.currentActivity.currentDay = moment(new Date(selectedActivity.start)).format('dddd D [de] MMMM [de] YYYY');
    $scope.currentActivity.favorite = selectedActivity.iSfavorite
    $scope.currentActivity.summary= selectedActivity.summary
    $scope.currentActivity.id= selectedActivity.id
    $scope.currentActivity.google_calendar_id = selectedActivity.google_calendar_id
    $scope.currentActivity.google_calendar_event = selectedActivity.google_calendar_event
  }

  const parseActivity = (activity, newActivity = {}) => {
    activity.ownerable = activity.ownerable || { id: null, name: null }
    if(activity.action_type === "internal") {
      newActivity.id = activity.id,
      newActivity.startDate= activity.begins_at,
      newActivity.endDate= activity.ends_at,
      newActivity.description= activity.description,
      newActivity.actionType= activity.action_type,
      newActivity.clientId= Number(sessionStorage.default_customer_id),
      newActivity.clientName = sessionStorage.default_customer_name,
      newActivity.ownerableType= activity.ownerable_type,
      newActivity.activityTypeCatalogId= activity.activity_type_catalog_id,

      $scope.selectedCustomer = {
        id: sessionStorage.default_customer_id,
        name: sessionStorage.default_customer_name
      }

    } else if(activity.action_type === "rh") {
      newActivity.id = activity.id,
      newActivity.startDate= activity.begins_at,
      newActivity.endDate= activity.ends_at,
      newActivity.description= activity.description,
      newActivity.actionType= activity.action_type,
      newActivity.clientId= Number(sessionStorage.default_customer_id),
      newActivity.clientName = sessionStorage.default_customer_name,
      newActivity.ownerableType= activity.ownerable_type,
      newActivity.activityTypeCatalogId= activity.activity_type_catalog_id,

      $scope.selectedCustomer = {
        id: sessionStorage.default_customer_id,
        name: sessionStorage.default_customer_name
      }

    }else if (activity.action_type === "vacation") {

      newActivity.id = activity.id
      newActivity.startDate= activity.begins_at
      newActivity.endDate= activity.ends_at
      newActivity.actionType= activity.action_type
      newActivity.description= "Vacaciones / Incapacidades"
      newActivity.ownerableType= null

    }else {
      newActivity.id = activity.id,
      newActivity.startDate= activity.begins_at,
      newActivity.endDate= activity.ends_at,
      newActivity.description= activity.description,
      newActivity.activityTypeCatalogId= activity.activity_type_catalog_id,
      newActivity.actionType= activity.action_type,
      newActivity.clientId= activity.ownerable_id,
      newActivity.clientName= activity.ownerable.name,
      newActivity.ownerableType= activity.ownerable_type,
      newActivity.projectId= activity.project_id,
      newActivity.productId= activity.product_catalog_id,
      newActivity.ticketId= activity.ticket_id,
      newActivity.ticketName= activity.ticket_name

      $scope.selectedCustomer = {
        id: activity.ownerable_id,
        name: activity.ownerable.name
      }
    }

    if(activity.action_type === "project"){
    newActivity.projectCode= "SCISA_0"+ activity.project.project_code,
    newActivity.projectName= activity.project.name,
      $scope.selectedProject = {
        id: activity.project.id,
        name: activity.project.name,
        client_id: activity.ownerable.id,
        client_name: activity.ownerable.name,
        code: activity.project.project_code
      }
    }

    if ((activity.action_type == "support" || activity.action_type === "project") && activity.ticket_id != null) {
      $scope.selectedTicket = {
        id: activity.ticket_id,
        title: activity.ticket_name
      }
    }

    newActivity.currentDay = moment(new Date(activity.begins_at)).format('dddd D [de] MMMM [de] YYYY');
    newActivity.favorite = activity.is_favorite
    newActivity.summary= activity.description
    newActivity.end= activity.ends_at
    newActivity.start= activity.begins_at
    newActivity.isRecurring = false
    newActivity.isValidate = true
    newActivity.isintoSia = true
    newActivity.editable = false
    newActivity.google_calendar_id = activity.google_calendar_id
    newActivity.google_calendar_event = activity.google_calendar_event

    return newActivity
  }

  const getActivities = (startOFWeek, endOFWeek) => {
    if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
      var selectedEmployeeId = $scope.selectedEmployee.id;
    } else {
      var selectedEmployeeId = JSON.parse(window.localStorage.apiUser).employee.id;
    }
    if($scope.userhasEmployee()){
      cfpLoadingBar.start();
      return Activity.index({
        params: {
          by_begins_at: {
            start_date: startOFWeek,
            end_date: endOFWeek
          },
          by_employee: selectedEmployeeId
        }
      }).then((response) => {
        return response.data.activities.map(activityRes => {
          let activity = parseActivity(activityRes)
          $scope.activities.push(activity)
          return activity;
        });
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        cfpLoadingBar.complete();
      });
    }else {
      toaster.pop('error', 'Empleado', 'Favor de ponerse en contacto con RH para que lo den de alta como empleado');
      return false
    }
  }




  const validateActTest = async () => {
    $scope.anyErrors = false;
    let newActivity = parseSaveActivity()
    cfpLoadingBar.start();
    await Activity.validate({activities: [newActivity]}).then((response) => {
    }).catch(error => {
      if ('errors' in error.data) {
        const errors = error.data.errors;
          errors.forEach(activityError => {
            Object.keys(activityError).forEach(activityKey => {
                activityError[activityKey].forEach(errorMsg => {
                    const errorString = `${errorMsg}`;
                    toaster.pop('error', 'Actividad', errorString);
                });
            });
        });
    } else {
        toaster.pop('error', 'Actividad', error.data.error);
    }
      $scope.anyErrors = true;
    }).finally(() => {
      cfpLoadingBar.complete();
    });
    return $scope.anyErrors
  }

  $scope.validateActMultipleTest = async (newActivity) => {
    $scope.anyErrors = false;
    cfpLoadingBar.start();
    return new Promise((resolve, reject) => {
        Activity.validate({activities: newActivity})
            .then((response) => {
                resolve();
            })
            .catch(error => {
              if ('errors' in error.data) {
                const errors = error.data.errors;
                errors.forEach((activityError) => {
                  Object.keys(activityError).forEach(activityKey => {
                      activityError[activityKey].forEach(errorMsg => {
                          const errorString = `[ ${moment(newActivity[activityKey].begins_at).format("h:mm")} ${moment(newActivity[activityKey].ends_at).format("h:mm a [del] D [de] MMMM")} ] ${errorMsg}`;
                          toaster.pop('error', 'Actividad', errorString);
                          let storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
                          for (let j = 0; j < storedWeekEvents.events.length; j++) {
                              if (storedWeekEvents.events[j].start === newActivity[activityKey].begins_at && storedWeekEvents.events[j].end === newActivity[activityKey].ends_at) {
                                  storedWeekEvents.events[j].isValidate = false;
                              }
                          }
                          $window.localStorage.weekCalendar = JSON.stringify(storedWeekEvents);
                      });
                  });
              });
              $('#myCalendar').fullCalendar('refetchEvents');
            } else {
                toaster.pop('error', 'Actividad', error.data.error);
            }
                $scope.anyErrors = true;
                reject();
            })
            .finally(() => {
                cfpLoadingBar.complete();
            });
    });
  };


  $scope.saveActIndividual = async (newActivity) => {
    await Activity.save({activity: newActivity}).then((response) => {
    }).catch(error => {
      if('errors' in error.data) {
        let errors = error.data.errors
        Object.keys(errors).map( e => {
          errors[e].map( r => {
            let errorString = `${e} ${r}`
            toaster.pop('error', 'Actividad', errorString);
          })
        })
      }else {
        toaster.pop('error', 'Actividad', error.data.error);
      }
      $scope.anyErrors = true;
    }).finally(() => {
      cfpLoadingBar.complete();
    });
    return $scope.anyErrors;
  }


  function validarFechas(eventos) {
    eventos.sort((a, b) => new Date(a.start) - new Date(b.start));
    const storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
    let hayEventosSuperpuestos = false;

    eventos.forEach((event, i) => {
      if (i === 0) return;
      const prevEvent = eventos[i - 1];
      if (new Date(prevEvent.end) > new Date(event.start)) {
        const storedEvent = storedWeekEvents.events.find(e => e.id === prevEvent.id);
        if (storedEvent) storedEvent.isValidate = false;
        hayEventosSuperpuestos = true;
      }
    });

    $window.localStorage.weekCalendar = JSON.stringify(storedWeekEvents);
    if (hayEventosSuperpuestos) {
      toaster.pop('error', 'Actividad', "Hay eventos con fechas en conflictos");
      $('#myCalendar').fullCalendar('refetchEvents');
      $mdDialog.cancel();
    }
    return !hayEventosSuperpuestos;
  }

  $scope.openImportAllWeek = function() {
    var currentScrollPosition = window.scrollY;
    $mdDialog.show({
        controller: $scope.SaveImportAllWeek,
        clickOutsideToClose: false,
        templateUrl: 'views/activities/_import_all_week.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
    })
  };

  $scope.SaveImportAllWeek = ['$scope', function($scope) {
    $scope.isSaving = false;
    $scope.save = async function() {
        if ($scope.isSaving) {
            return;
        }
        $scope.isSaving = true;
        try {
            await $scope.importAllWeek();
            $mdDialog.hide();
        } catch (error) {
            toaster.pop('error', 'Error en la importación', error.message || 'Hubo un error al importar las actividades de la semana');
            $mdDialog.cancel();
        } finally {
            $scope.isSaving = false;
        }
    };
    $scope.cancel = function() {
        $mdDialog.cancel();
    };
  }];

  $scope.importAllWeek = async () => {
    if (!('weekCalendar' in $window.localStorage)) {
        toaster.pop('error', 'Actividad', "No tienes ninguna actividad de la semana guardada");
        $mdDialog.cancel();
        return;
    }
    const storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
    const WeekEventEvents = storedWeekEvents.events;
    if (WeekEventEvents.length === 0) {
        toaster.pop('error', 'Actividad', "No tienes ninguna actividad");
        $mdDialog.cancel();
        return;
    }
    const eventsToImport = WeekEventEvents.filter(event => event.isValidate !== false);
    const eventsNeedingClassification = WeekEventEvents.filter(event => event.isValidate === false);
    if (eventsToImport.length === 0) {
        toaster.pop('error', 'Actividad', "Todas las actividades necesitan clasificación (proyecto, soporte, cotización o cliente) antes de poder importarse");
        $mdDialog.cancel();
        return;
    }
    const idEventsSIA = (await getActivities(storedWeekEvents.startOfWeek, storedWeekEvents.endOfWeek)).map(act => act.id);
    const eventosParseados = eventsToImport.map(event => {
        const classificationChanges = GoogleCalendarEvents.classificationChanges(event);
        const hasSnapshot = classificationChanges !== null;
        const payload = {
            begins_at: event.start,
            ends_at: event.end,
            description: event.description,
            action_type: event.actionType,
            activity_type_catalog_id: event.activityTypeCatalogId,
            ownerable_id: event.clientId,
            ownerable_type: event.ownerableType,
            project_id: event.projectId,
            product_catalog_id: event.productId,
            ticket_id: event.ticketId,
            ticket_name: event.ticketName,
            is_favorite: event.favorite,
            google_calendar_id: event.isintoSia ? event.google_calendar_id : event.id,
            google_calendar_event: event.google_calendar_event != undefined && event.google_calendar_event != null ? JSON.stringify(event.google_calendar_event) : null,
            attendees: event.attendees ? JSON.stringify(event.attendees) : null,
        };
        if (hasSnapshot) {
            payload.classification_metadata    = JSON.stringify(event._originalClassification);
            payload.classification_changes     = JSON.stringify(classificationChanges);
            payload.is_correctly_classified    = classificationChanges.length === 0;
        }
        return payload;
    });
    if (!validarFechas(eventsToImport)) return;
    try {
        await $scope.validateActMultipleTest(eventosParseados);
        await Promise.all(idEventsSIA.map(id => Activity.delete(id)));
        for (const event of eventosParseados) {
          await $scope.saveActIndividual(event);
        }
        $state.go('app.activities');
        if (eventsNeedingClassification.length > 0) {
            storedWeekEvents.events = eventsNeedingClassification;
            $window.localStorage.weekCalendar = JSON.stringify(storedWeekEvents);
            toaster.pop('warning', 'Actividad', `Se importaron ${eventsToImport.length} actividades. ${eventsNeedingClassification.length} necesitan clasificación antes de poder importarse.`);
        } else {
            $window.localStorage.removeItem('weekCalendar');
            toaster.pop('success', 'Actividad', 'Todas las actividades se agregaron correctamente');
        }
    } catch (error) {
        toaster.pop('error',"Error en el Proceso");
        $mdDialog.cancel();
    }
  };

  $scope.openImportOneDayOfWeek = function(selectedDay) {
    $scope.selectedDay = selectedDay;
    var currentScrollPosition = window.scrollY;
    $mdDialog.show({
        controller: $scope.SaveImportOneDayOfWeek,
        clickOutsideToClose: false,
        templateUrl: 'views/activities/_import_OneDay_week.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
    })
  };

  $scope.SaveImportOneDayOfWeek = ['$scope', function($scope) {
    $scope.isSaving = false;
    $scope.save = async function() {
        if ($scope.isSaving) {
            return;
        }
        $scope.isSaving = true;
        try {
            await $scope.importOneDayofWeek($scope.selectedDay);
            $mdDialog.hide();
        } catch (error) {
            toaster.pop('error', 'Error en la importación', error.message || 'Hubo un error al importar las actividades de la semana');
            $mdDialog.cancel();
        } finally {
            $scope.isSaving = false;
        }
    };
    $scope.cancel = function() {
        $mdDialog.cancel();
    };
  }];


  $scope.importOneDayofWeek = async (selectedDay) => {
    if (!selectedDay) {
      toaster.pop('error', 'Actividad', "No tienes ningun día seleccionado");
      $mdDialog.cancel();
      return;
    }
    if (!('weekCalendar' in $window.localStorage)) {
        toaster.pop('error', 'Actividad', "No tienes ninguna actividad de la semana guardada");
        $mdDialog.cancel();
        return;
    }
    const storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
    let WeekEventEvents = storedWeekEvents.events;

    let eventsToRemove = WeekEventEvents.filter((event) => {
      return (new Date(event.start).getDate() === new Date(selectedDay).getDate())
    });

    if (eventsToRemove.length === 0) {
      toaster.pop('error', 'Actividad', "No tienes ninguna actividad");
      $mdDialog.cancel();
      return;
    }
    const eventsToImport = eventsToRemove.filter(event => event.isValidate !== false);
    const eventsNeedingClassification = eventsToRemove.filter(event => event.isValidate === false);
    if (eventsToImport.length === 0) {
      toaster.pop('error', 'Actividad', "Todas las actividades de este día necesitan clasificación (proyecto, soporte, cotización o cliente) antes de poder importarse");
      $mdDialog.cancel();
      return;
    }
    let inicioDelDia =  new Date(selectedDay);
    inicioDelDia.setHours(0, 0, 0, 0);

    let finalDelDia =  new Date(selectedDay);
    finalDelDia.setHours(23, 59, 59, 999);
    const idEventsSIA = (await getActivities(inicioDelDia,finalDelDia)).map(act => act.id);

    const eventosParseados = eventsToImport.map(event => {
        const classificationChanges = GoogleCalendarEvents.classificationChanges(event);
        const hasSnapshot = classificationChanges !== null;
        const payload = {
            begins_at: event.start,
            ends_at: event.end,
            description: event.description,
            action_type: event.actionType,
            activity_type_catalog_id: event.activityTypeCatalogId,
            ownerable_id: event.clientId,
            ownerable_type: event.ownerableType,
            project_id: event.projectId,
            product_catalog_id: event.productId,
            ticket_id: event.ticketId,
            ticket_name: event.ticketName,
            is_favorite: event.favorite,
            google_calendar_id: event.isintoSia ? event.google_calendar_id : event.id,
            google_calendar_event: event.google_calendar_event != undefined && event.google_calendar_event != null ? JSON.stringify(event.google_calendar_event) : null,
            attendees: event.attendees ? JSON.stringify(event.attendees) : null,
        };
        if (hasSnapshot) {
            payload.classification_metadata    = JSON.stringify(event._originalClassification);
            payload.classification_changes     = JSON.stringify(classificationChanges);
            payload.is_correctly_classified    = classificationChanges.length === 0;
        }
        return payload;
    });
    if (!validarFechas(eventsToImport)) return;
    try {
        await $scope.validateActMultipleTest(eventosParseados);
        await Promise.all(idEventsSIA.map(id => Activity.delete(id)));
        for (const event of eventosParseados) {
          await $scope.saveActIndividual(event);
        }
        WeekEventEvents = WeekEventEvents.filter(event => !eventsToImport.includes(event));
        storedWeekEvents.events = WeekEventEvents;
        $window.localStorage.weekCalendar = JSON.stringify(storedWeekEvents);
        await actualizarActividadesEnCalendario(new Date(storedWeekEvents.startOfWeek), new Date(storedWeekEvents.endOfWeek));
        var view = $('#myCalendar').fullCalendar('getView');
        view.calendar.refetchEvents()
        $state.go('app.activities');
        if (eventsNeedingClassification.length > 0) {
            toaster.pop('warning', 'Actividad', `Se importaron ${eventsToImport.length} actividades. ${eventsNeedingClassification.length} necesitan clasificación antes de poder importarse.`);
        } else {
            toaster.pop('success', 'Actividad', 'Todas las actividades se agregaron correctamente');
        }
    } catch (error) {
        toaster.pop('error',"Error en el Proceso",error);
        $mdDialog.cancel();
    }
  };

  $scope.SaveImportActivityCtrl = ['$scope', function($scope) {
    $scope.save = function() {
      cfpLoadingBar.start();
      validateActTest().then(() => {
        if (!$scope.anyErrors) {
          let storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
          let eventToUpdate = storedWeekEvents.events.find(event => event.id === $scope.currentActivity.id);
          if (eventToUpdate) {
            Object.assign(eventToUpdate, $scope.currentActivity, {isValidate: true});
            $window.localStorage.weekCalendar = JSON.stringify(storedWeekEvents);
            $scope.refreshCalendar = true;
            $mdDialog.hide();
            cfpLoadingBar.complete();
            toaster.pop('success', 'Actividad', 'La actividad se edito correctamente');
          }
        }
      });
    };
    $scope.cancel = $mdDialog.cancel;
  }];


  $scope.editEventsDates = (selectedActivity, delta, reverFunc, jsEvent, ui, view) => {
    if (selectedActivity.allDay || $scope.isProcessing) {
        reverFunc();
        toaster.pop('warning', 'Actividad', 'Se necesita crear la actividad desde el SIA');
        return;
    }
    $scope.isProcessing = true;
    cfpLoadingBar.start();

    let storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
    let eventToUpdate = storedWeekEvents.events.find(event => event.id === selectedActivity.id);

    if ($scope.draggingIcon) {
        let currentTime = new Date();
        let timeSuffix = currentTime.getHours().toString().padStart(2, '0') + currentTime.getMinutes().toString().padStart(2, '0') + currentTime.getSeconds().toString().padStart(2, '0');
        let copiedActivity = {...selectedActivity, id: selectedActivity.id + "CP-" + timeSuffix, _id: selectedActivity.id + "CP-" + timeSuffix};
        storedWeekEvents.events.push(copiedActivity);
    } else if (eventToUpdate) {
        selectedActivity.isValidate = true;
        Object.assign(eventToUpdate, selectedActivity);
    } else {
        handleError('La actividad no se encontró para actualizar', reverFunc);
    }

    $window.localStorage.weekCalendar = JSON.stringify(storedWeekEvents);
    view.calendar.refetchEvents();
    cfpLoadingBar.complete();
    $scope.isProcessing = false;
    $scope.draggingIcon = false;
  };

  function handleError(message, reverFunc) {
    console.error(message);
    toaster.pop('error', 'Error', message);
    if (reverFunc) reverFunc();
  }

  $scope.eventsClick = (event, jsEvent, view) => {
    if ('weekCalendar' in $window.localStorage) {
        let storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
        if (event.start._i >= storedWeekEvents.startOfWeek && event.start._i <= storedWeekEvents.endOfWeek) {
          if (event.isintoSia) {
            $scope.isEditable = false;
            $scope.isDisabled = true;
          } else {
            $scope.isEditable = true;
            $scope.isDisabled = false;
          }
            parseCurrentActivity(event);
            $scope.newCurrentActivity = event;
            $scope.clearIcon = event.actionType === "internal" || event.actionType === "rh" ? false : true;
            if (["support", "quote"].includes(event.actionType)) {
              validateCustomerAndFilterProducts($scope.newCurrentActivity.clientId, $scope.newCurrentActivity.ownerableType);
            }
            var currentScrollPosition = window.scrollY;
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: $scope.SaveImportActivityCtrl,
                templateUrl: 'views/activities/_import-activity-modal.html',
                scope: $scope,
                preserveScope: true,
                onRemoving: function() {
                  window.scrollTo(0, currentScrollPosition);
                }
            }).catch(() => {}).finally(() => {
                if ($scope.refreshCalendar) {
                    view.calendar.refetchEvents()
                }
                $scope.refreshCalendar = false;
                $scope.currentActivity = {};
            });
        } else {
          return false;
        }
    } else {
      return false
    }
  };

  var scrollTime = moment().format("HH") + ":00:00";
  function isEventOverDiv(x, y) {
      var trashEl = $('#trash');
      var offset = trashEl.offset();
      offset.right = offset.left + trashEl.outerWidth();
      offset.bottom = offset.top + trashEl.outerHeight();
      return x >= offset.left
          && y >= offset.top
          && x <= offset.right
          && y <= offset.bottom;
  }

  async function actualizarActividadesEnCalendario(startOfDay, endOfDay) {
    try {
        const hasNonDateChanges = (existingEvent, newEvent) => {
            for (let key in newEvent) {
                if (key !== 'start' && key !== 'end' && newEvent[key] !== existingEvent[key]) {
                    return true;
                }
            }
            return false;
        };

        let weekCalendar = JSON.parse(window.localStorage.getItem('weekCalendar')) || { events: [] };
        let activities = await getActivities(startOfDay, endOfDay);

        if (weekCalendar.importType === "CSV") {

           activities.forEach(newEvent => {
            let existingEvent = weekCalendar.events.find(event => event.id === newEvent.id);
              if (existingEvent) {
                  if (existingEvent.isintoSia && hasNonDateChanges(existingEvent, newEvent)) {
                    let { start, end  } = existingEvent;
                    Object.assign(existingEvent, newEvent);
                    existingEvent.start = start;
                    existingEvent.end = end;
                  }
              } else {
                  weekCalendar.events.push(newEvent);
              }
            });

        } else {
            let events = await GoogleCalendarEvents.fetchWeek(startOfDay, endOfDay, googleDeps());
            let filteredEvents = events.filter(event =>
                !activities.find(activity => activity.google_calendar_id === event.id)
            );

            let newEvents = activities.concat(filteredEvents);

            newEvents.forEach(newEvent => {
                let existingEvent = weekCalendar.events.find(event => event.id === newEvent.id);
                if (existingEvent) {
                    if (existingEvent.isintoSia && hasNonDateChanges(existingEvent, newEvent)) {
                       let { start, end  } = existingEvent;
                       Object.assign(existingEvent, newEvent);
                       existingEvent.start = start;
                       existingEvent.end = end;
                    }
                } else {
                    weekCalendar.events.push(newEvent);
                }
            });

            weekCalendar.events = weekCalendar.events.filter(event =>
                activities.find(activity => activity.id === event.id) ||
                events.find(e => e.id === event.id) || /\d*CP-/.test(event.id)
            );
        }

        window.localStorage.setItem('weekCalendar', JSON.stringify(weekCalendar));
        let storedWeekCalendar = JSON.parse(window.localStorage.getItem('weekCalendar'));

        if (storedWeekCalendar && storedWeekCalendar.events.length === weekCalendar.events.length) {
            toaster.pop('success', 'Actividad', 'Las actividades se actualizaron localmente de manera correcta');
        } else {
            toaster.pop('error', 'Error', 'Revise sus actividades. Puede que haya superado el límite o el formato sea incorrecto.');
            throw new Error('Error al guardar en el almacenamiento local.');
        }
    } catch (error) {
        toaster.pop('error', 'Error', 'Revise sus actividades. Puede que haya superado el límite o el formato sea incorrecto.');
        console.error('Error al obtener los eventos:', error);
    } finally {
        cfpLoadingBar.complete();
    }
}
  $scope.openImportWeekCsv = function() {
    var currentScrollPosition = window.scrollY;
    $mdDialog.show({
        controller: $scope.SaveImportWeekCsv,
        clickOutsideToClose: false,
        templateUrl: 'views/activities/_import_activity_csv.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
    })
  };

  $scope.SaveImportWeekCsv = ['$scope', function($scope) {
    $scope.isSaving = false;
    $scope.file = null;

    $scope.downloadFormatCsv = () => {
      return Activity.downloadFormatCsv().then((response) => {
        var blob = new Blob([response.data]);
        FileSaver.saveAs(blob, 'Formato_Actividades.csv');
        toaster.pop('success', 'Actividades', 'Se descargo el csv de las actividades');
      }).catch(error => {
        console.error(error);
        toaster.pop('error', 'Actividades', error.data.error);
      });
    }

    $scope.updateFile = function(files) {
      $scope.$apply(function() {
        $scope.file = files[0];
      });
    };

    $scope.save = async function() {
      if ($scope.isSaving) {
        return;
      }

      if (!$scope.file || $scope.file.type != 'text/csv') {
        toaster.pop('error', 'Error en la importación', 'Archivo no válido o no seleccionado.');
        return;
      }

      $scope.isSaving = true;

      var formData = new FormData();
      formData.append('file', $scope.file);

      try {
        if (window.confirm('¿Estás seguro que deseas importar estas actividades?')) {

          cfpLoadingBar.start();
          var view = $('#myCalendar').fullCalendar('getView');
          var startOfDay = new Date (view.start.clone().add(1, 'days'));
          var endOfDay =  new Date (view.end.clone());
          endOfDay.setHours(23,59,59,999);
          startOfDay.setHours(0,0,0,0);
          let diasDeSemana = [];
          let fechaActual = new Date(startOfDay);
          while (fechaActual <= endOfDay) {
              diasDeSemana.push(new Date(fechaActual));
              fechaActual.setDate(fechaActual.getDate() + 1);
          }
          try {
          let activities = await getActivities(startOfDay, endOfDay);
          let response = await Activity.ActivitiesCsv(formData,startOfDay);
          let importedActivities = response.data.import_activities;

          let filteredEvents = importedActivities.filter(event =>
            !activities.find(activity => activity.google_calendar_id === event.id)
          );
          let combinedActivities = activities.concat(filteredEvents);
          let weekEvents = { importType: "CSV", startOfWeek: startOfDay, endOfWeek: endOfDay, events: combinedActivities};

          window.localStorage.setItem('weekCalendar', JSON.stringify(weekEvents));

          toaster.pop('success', 'Importación de actividades', 'Se importaron correctamente las actividades');
          $mdDialog.hide();

          } catch(error) {
            let errorMessages = '';
            if (Array.isArray(error.data.errors)) {
              errorMessages = error.data.errors.join('<br>');
            } else {
              errorMessages = String(error.data.errors);
            }

            toaster.pop('error', 'Error en importación', errorMessages, null, 'trustedHtml');
          }

          view.calendar.refetchEvents()
          cfpLoadingBar.complete();
        }
      } catch (error) {
        toaster.pop('error', 'Error en la importación', error.message || 'Hubo un error al importar las actividades de la semana');
        $mdDialog.cancel();
      } finally {
        $scope.isSaving = false;
      }
    };
    $scope.cancel = function() {
      $mdDialog.cancel();
    };
  }];


  $scope.uiGoogleCalendar= {
    calendar: {
      timezone: 'local',
      firstDay: 1,
      height: 750,
      droppable: true,
      nowIndicator: true,
      allDaySlot: true,
      allDayText: 'Importar el día',
      selectable: true,
      scrollTime: scrollTime,
      slotDuration: "00:15:00",
      defaultView: 'agendaWeek',
      eventOverlap: false,
      header:{
        left: $scope.leftButtons,
        center: 'title',
        right: 'today prev,next'
      },
      defaultDate: $scope.saveDate,
      dayClick: function(date, jsEvent, view) {
        if (date._ambigTime || date._ambigZone) {
        var startOfDay = new Date (date.clone().add(1, 'days'));
        startOfDay.setHours(0,0,0,0);
        $scope.openImportOneDayOfWeek(startOfDay)
      }
    },
      eventDragStop: function(event, jsEvent, ui, view) {
        if (isEventOverDiv(jsEvent.clientX, jsEvent.clientY)) {
            cfpLoadingBar.start();
            let storedEvents = JSON.parse($window.localStorage.weekCalendar);
            let indexToRemove = storedEvents.events.findIndex(e => e.id === event.id);
            if (indexToRemove !== -1) {
                storedEvents.events.splice(indexToRemove, 1);
                localStorage.setItem('weekCalendar', JSON.stringify(storedEvents));
                view.calendar.refetchEvents()
                cfpLoadingBar.complete();
            } else {
                cfpLoadingBar.complete();
            }
        }
      },
      customButtons: {
        myCustomButton: {
          text: 'Importar actividades localmente (Google Calendar)',
          click: async function() {
            let confirmImport = window.confirm("¿Deseas importar las actividades localmente del Google Calendar a la semana actual?");
            if (confirmImport) {
              cfpLoadingBar.start();
              var view = $('#myCalendar').fullCalendar('getView');
              var startOfDay = new Date (view.start.clone().add(1, 'days'));
              var endOfDay =  new Date (view.end.clone());
              endOfDay.setHours(23,59,59,999);
              startOfDay.setHours(0,0,0,0);
              let diasDeSemana = [];
              let fechaActual = new Date(startOfDay);
              while (fechaActual <= endOfDay) {
                  diasDeSemana.push(new Date(fechaActual));
                  fechaActual.setDate(fechaActual.getDate() + 1);
              }
              try {
                let activities = await getActivities(startOfDay, endOfDay);
                let events = await GoogleCalendarEvents.fetchWeek(startOfDay, endOfDay, googleDeps());
                let filteredEvents = events.filter(event =>
                    !activities.find(activity => activity.google_calendar_id === event.id)
                );
                let combined = activities.concat(filteredEvents);
                let weekEvents = { importType: "GCL", startOfWeek: startOfDay, endOfWeek: endOfDay, events: combined};
                window.localStorage.setItem('weekCalendar', JSON.stringify(weekEvents));
                toaster.pop('success', 'Actividad', 'Las actividades se guardaron correctamente');
              } catch(error) {
                toaster.pop('error', 'Error en importación', 'Revise sus actividades. Puede que haya superado el límite o el formato sea incorrecto');
                console.error('Error al obtener los eventos:', error);
              }
              view.calendar.refetchEvents()
              cfpLoadingBar.complete();
            }
          }
        },
        csvImportButton: {
          text: 'Importar actividades localmente (CSV)',
          click: async function() {
            $scope.openImportWeekCsv();
          }
        },
        removeWeekButton: {
          text: 'Remover semana',
          click: async function() {
            var view = $('#myCalendar').fullCalendar('getView');
            if ('weekCalendar' in $window.localStorage) {
              let confirmRemove = window.confirm("¿Deseas remover las actividades de la semana?");
              if (confirmRemove) {
                cfpLoadingBar.start();
                try {
                  $window.localStorage.removeItem('weekCalendar');
                  toaster.pop('success', 'Actividad', 'Las actividades se removieron correctamente');
                } catch(error) {
                  toaster.pop('error', 'Actividad', error.data.error);
                }
                cfpLoadingBar.complete();
              }
            } else {
              toaster.pop('error', 'Actividad', 'No se encontró ninguna semana almacenada');
            }
            view.calendar.refetchEvents()
          }
        },
        updateCalendarButton: {
          text: 'Refrescar actividades',
          click: async function() {
              var view = $('#myCalendar').fullCalendar('getView');
              var startOfDay = new Date (view.start.clone().add(1, 'days'));
              var endOfDay =  new Date (view.end.clone());
              endOfDay.setHours(23,59,59,999);
              startOfDay.setHours(0,0,0,0);
              try {
                let weekCalendar = window.localStorage.getItem('weekCalendar');
                  if (weekCalendar) {
                      await actualizarActividadesEnCalendario(startOfDay,endOfDay)
                  } else {
                      toaster.pop('error', 'Actividad', 'No se encontró ninguna semana almacenada');
                  }
              } catch(error) {
                  console.error('Error al obtener los eventos:', error);
              }
              view.calendar.refetchEvents()
          }
        }
      },
      eventDragStart:(selectedActivity, jsEvent, ui, view) => {
        if (jsEvent.target.id === 'copy') {
            $scope.draggingIcon = true;
        } else {
            $scope.draggingIcon = false;
        }
      },
      eventDrop: $scope.editEventsDates,
      eventResize: $scope.editEventsDates,
      eventClick:  $scope.eventsClick,
      events: async (start, end, timezone, callback) => {
        cfpLoadingBar.start();
        var startOfDay = new Date(start.clone().add(1, 'days'));
        var endOfDay = new Date(end.clone());
        endOfDay.setHours(23,59,59,999);
        startOfDay.setHours(0,0,0,0);
        let events;
        if ('weekCalendar' in $window.localStorage) {
            const storedWeekEvents = JSON.parse($window.localStorage.weekCalendar);
            if (JSON.stringify(storedWeekEvents.startOfWeek) === JSON.stringify(startOfDay)) {
                events = storedWeekEvents.events.map(event => ({...event, editable: true}));
            }
        }
        callback(events);
        cfpLoadingBar.complete();
      },
      eventRender: (event, element, view) => {
        const weekCalendar = JSON.parse($window.localStorage.getItem('weekCalendar') || '{}');
        const isEventInStoredWeek = event.start._i >= weekCalendar.startOfWeek && event.start._i <= weekCalendar.endOfWeek;
        if (!event.end) {
          console.error('[Calendar] Event without end:', event);
        }
        var start = event.start;
        var end = event.end || moment(event.start).add(15, 'minutes');
        element.html(`
            <i class="fa fa-clock-o" aria-hidden="true" style="padding: 5px 0px 0px 5px;"></i>
            <i style="font-family: sans-serif; font-style: normal; font-size: 13px;">${moment(start._d).format("h:mm")} - ${moment(end._d).format("h:mm a")}</i>
            <br/><i style="font-family: sans-serif; font-style: normal; margin-left: 5px;">${event.description}</i>
        `);
        if (isEventInStoredWeek) {
          var color_mapping = {
            'vacation': '#5F9EA0',
            'quote': '#7a7db3',
            'support': '#df6c11',
            'internal': '#e3a60d',
            'project': '#4153c8',
            'rh': '#4682b4'
         };

        const color = !event.isValidate ? '#9e2a2a' : event.isintoSia ? '#c47c42' : color_mapping[event.actionType];
            view.calendar.unselect();
            element.css('background-color', color).css('border-color', color).prepend(`
                <div class="fc-resizer fc-end-resizer"></div>
                <i class="fa fa-files-o fa-2x pull-right" aria-hidden="true" id="copy" style="padding: 5px; transition: transform .2s;"></i>
            `);
        }
      }
    }
  };

  $scope.isWeekSaved = function() {
    return 'weekCalendar' in $window.localStorage;
  };

  $scope.updateWeekLocalStorage = function() {
      $scope.weekLocalStorage = $scope.isWeekSaved() ? JSON.parse($window.localStorage.getItem('weekCalendar')) : null;
      if ($scope.weekLocalStorage) {
        $scope.leftButtons = 'removeWeekButton updateCalendarButton';
        $scope.saveDate = $scope.weekLocalStorage.startOfWeek;
      } else {
        $scope.leftButtons = 'myCustomButton csvImportButton';
        $scope.saveDate = null;
      }

      $scope.uiGoogleCalendar.calendar.header = {
          left: $scope.leftButtons,
          center: 'title',
          right: 'today prev,next'
      };

      $scope.uiGoogleCalendar.calendar.defaultDate = $scope.saveDate;
  };


  $scope.$watch(function() {
      return $window.localStorage.weekCalendar;
  }, function(newValue, oldValue) {
      if (newValue !== oldValue) {
          $scope.updateWeekLocalStorage();
      }
  });

  const getRecentActivities = () => {
    if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
      var selectedEmployeeId = $scope.selectedEmployee.id;
    } else {
      var selectedEmployeeId = JSON.parse(window.localStorage.apiUser).employee.id;
    }
    if($scope.userhasEmployee()){
      cfpLoadingBar.start();
      return Activity.recentActivities({
        params: {
          employee_id: selectedEmployeeId,
        }
      }).then((response) => {
        $scope.recentActivities = response.data.activities.map(activityRes => {
          let activity = parseActivity(activityRes)
          return activity;
        });
      });
    }else {
      toaster.pop('error', 'Empleado', 'Favor de ponerse en contacto con RH para que lo den de alta como empleado');
      return false
    }
  }
  getRecentActivities();

  $scope.resetCurrentActivity = function() {
    $scope.currentActivity.actionType = null;
    $scope.currentActivity.ownerableType=  null;
    $scope.currentActivity.activityTypeCatalogId= null;
    $scope.currentActivity.projectId=  null;
    $scope.currentActivity.projectName=  null;
    $scope.currentActivity.clientId=  null;
    $scope.currentActivity.clientName=  null;
    $scope.currentActivity.project_code=  null;
    $scope.currentActivity.productId=  null;
    $scope.currentActivity.ticketId=  null;
    $scope.currentActivity.ticketName=  null;
    $scope.searchProject =   null;
    $scope.searchTicket =  null;
    $scope.selectedCustomer = null;
    $scope.clearIcon = true;
  };

  $scope.fillWithRecentValues = function() {
    let recent = $scope.currentActivity.recentActivity;
    if (recent) {

      $scope.resetCurrentActivity();

      let action_type = $scope.actionTypes.find(action_type => action_type.id == recent.actionType);
      $scope.currentActivity.actionType = action_type.id;
      $scope.currentActivity.ownerableType = recent.ownerableType;
      $scope.currentActivity.activityTypeCatalogId = recent.activityTypeCatalogId;

      if(action_type.id === "project") {
        $scope.searchProject = recent.projectName;
        $scope.currentActivity.projectId = recent.projectId;
        $scope.currentActivity.projectName = recent.projectName
        $scope.currentActivity.clientId = recent.clientId
        $scope.currentActivity.clientName = recent.clientName
        $scope.currentActivity.ownerableType = recent.ownerableType
        $scope.currentActivity.project_code = recent.projectCode
        $scope.clearIcon = false;
        $scope.selectedCustomer = {
          id: recent.clientId,
          name: recent.clientName
        }
      }
      else if(action_type.id === "support" || action_type.id === "internal" || action_type.id === "rh") {
        $scope.currentActivity.clientId = recent.clientId;
        $scope.currentActivity.ownerableType = recent.ownerableType;
        errorShown = false;
        $scope.selectedCustomer = {
          id: recent.clientId,
          name: recent.clientName
        }
        $scope.selectedCustomerChange($scope.selectedCustomer);
        $scope.currentActivity.productId = recent.productId;

      } else if (action_type.id === "quote" ){
        $scope.currentActivity.clientId = recent.clientId;
        $scope.currentActivity.ownerableType = recent.ownerableType;
        errorShown = false;
        $scope.selectedCustomer = {
          id: recent.clientId,
          name: recent.clientName
        }
        validateCustomerAndFilterProducts(recent.clientId, recent.ownerableType);
        $scope.currentActivity.productId = recent.productId;
      }

      $scope.currentActivity.ticketId = recent.ticketId;
      $scope.currentActivity.ticketName = recent.ticketName;
      if (recent.ticketId != null) {
        $scope.searchTicket = recent.ticketId + ", " + recent.ticketName;
      }
      else {
        $scope.searchTicket = "";
      }
    }
  }

  $scope.updateWeekLocalStorage();
  cfpLoadingBar.start();
  getCatalogParmas().finally(() => cfpLoadingBar.complete());
}]);
